import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { getCompanies } from "../api";

export const useCompanySwitchStore = create()(
  persist(
    devtools((set, get) => ({
      companies: [],
      selectedCompany: null,
      setSelectedCompany: (company) =>
        set((state) => ({
          selectedCompany: company,
        })),
      fetchCompanies: async () => {
        const response = await getCompanies(["available_modules"]);

        set((state) => ({
          companies: response?.data?.data,
          selectedCompany:
            state.selectedCompany &&
            state.selectedCompany?.available_modules?.data?.length > 0
              ? state.selectedCompany
              : response?.data?.data[0],
        }));
      },
    })),
    { name: "Company_Switch_Store", version: 1 }
  )
);
